import { render } from "./WarehouseSettingsParameters.vue?vue&type=template&id=0e9b97ce&scoped=true"
import script from "./WarehouseSettingsParameters.vue?vue&type=script&lang=js"
export * from "./WarehouseSettingsParameters.vue?vue&type=script&lang=js"

import "./WarehouseSettingsParameters.vue?vue&type=style&index=0&id=0e9b97ce&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9b97ce"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QToggle});
